// src/redux/settingsPages/security/securityActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import SecurityAPI from './securityAPI';

export const setupMfaThunk = createAsyncThunk(
  'security/setupMfa',
  async (_, { rejectWithValue }) => {
    try {
      return await SecurityAPI.setupMfa();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to start MFA setup');
    }
  }
);

export const verifyMfaSetupThunk = createAsyncThunk(
  'security/verifyMfaSetup',
  async (code, { rejectWithValue }) => {
    try {
      await SecurityAPI.verifyMfaSetup(code);
      return true;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Invalid code');
    }
  }
);

export const disableMfaThunk = createAsyncThunk(
  'security/disableMfa',
  async (code, { rejectWithValue }) => {
    try {
      await SecurityAPI.disableMfa(code);
      return true;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Invalid code');
    }
  }
);
